import { Injectable } from '@angular/core';
import { LMContextService, LMLoggerService } from '@app/services';
import { LMContextUtilService } from '@app/utils';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";

@Injectable()
export class ActivateGuard implements CanActivate {
  constructor(
      private lmContextService: LMContextService,
      private lmContextUtilService: LMContextUtilService,
      private lmLoggerService: LMLoggerService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (!this.lmContextService.inMingle() || !this.lmContextUtilService.inStartMode()) {
      return Promise.resolve(true);
    }

    // Avoid a flash effect on the initial load of a drillback or favorite in the Portal.
    // Wait for a Portal message. When it comes in, cancel the current route and let the drillback or favorite load.
    // On a timeout, let the current route load.
    return this.lmContextUtilService.waitForPortalMessage(state).then(msgReceived => {
      if (msgReceived) {
        this.lmLoggerService.log([ 'ActivateGuard', 'canActivate', 'Cancelling route', route.routeConfig?.component?.name ]);
      }
      return !msgReceived;
    });
  }
}
